/**
 * Default `maxAgeMs` sent with account summary, positions and strategy
 * composition reads when the caller does not specify one (PWA-2810).
 * Callers that need fresher data pass their own value (0 forces a refetch).
 */
export const DEFAULT_ACCOUNT_DATA_MAX_AGE_MS = 10 * 60 * 1000;
